import { LANGUAGES, TUrl } from "./types";

export const DEFAULT_BASE_URL: TUrl = "https://api.beamimpact.com";

export const DEFAULT_LOG_URL = "https://production.beamimpactlogs.com";

export const SUPPORTED_LANGUAGES: Record<string, LANGUAGES> = {
  en: "en",
  fr: "fr",
  de: "de",
  es: "es",
  it: "it",
  pl: "pl",
  ja: "ja",
};

export const WIDGET_NAMES = {
  select_nonprofit: "select-nonprofit",
  redeem_transaction: "redeem-transaction",
  impact_overview: "impact-overview",
  community_impact: "community-impact",
  cumulative_impact: "cumulative-impact",
  product_details_page: "product-details-page",
  subscription_management: "subscription-management",
  subscription_impact: "subscription-impact",
  select_subscription_nonprofit: "select-subscription-nonprofit",
  social_share: "social-share",
  subscriber_select_nonprofit: "subscriber-select-nonprofit",
} as const;

export const SELECTION_METHODS = {
  dashboard: "dashboard",
  remote_order: "remote_order",
  checkout: "checkout",
  subscription_management_widget: "subscription_management_widget",
  subscriber_select_nonprofit_widget: "subscriber_select_nonprofit_widget",
} as const;

export const HELPER_NAMES = {
  cart_update: "cart_update",
};

/**
 * Every localStorage key this SDK writes.
 */
export const LOCAL_STORAGE_KEYS = {
  // Last selection id
  TRANSACTION: "transaction",
  // Cached cart snapshot used to detect changes across page loads/tabs
  CART: "cart",
  // Stored promo codes captured for the current cart
  PROMO: "promos",
  // Last-selected nonprofit id
  NONPROFIT: "nonprofit",
  // Timestamp of that nonprofit selection
  NONPROFIT_SELECTED_AT: "nonprofit_selected_at",
  // Cached chain nonprofit list
  CHAIN_NONPROFITS: "chainNonprofits",
  // Statsig stable id, mirrored into localStorage for cart-linking
  REMOTE_SESSION_ID: "remote_session_id",
} as const;

/**
 * Every cookie this SDK sets, across the cart integration and its sibling integrations.
 */
export const BEAM_COOKIE_NAMES = {
  // Beam's own cart id, used to identify the cart across subdomains
  CART: "beam_cart",
  // Promo codes captured for the current cart
  PROMO_CODES: "beam_promo_codes",
  // Cross-subdomain session id set by the separate Session integration
  SESSION: "beam_session",
  // Statsig A/B stable id, cached in a cookie to persist across subdomains
  STATSIG_STABLE_ID: "beam_statsig_session_id",
} as const;
